import React, { Component } from 'react'
import { observer } from "mobx-react"
import { Table } from 'antd'

const SEX_MAP = new Map([[1, '男'], [2, '女']])

@observer
class SampleInfo extends Component {
  render() {
    const { detailData: { relations } } = this.props.store
    const columns = [
      {
        title: '编号',
        dataIndex: 'name',
        width: 100,
        render: (text, record, index) => {
          const obj = {
            children: text,
            props: {
              rowSpan: 1
            }
          }
          let endIndex
          // 相同编号名的数量
          const sameCount = relations.filter(item => {
            endIndex = index
            return item.name === text
          }).length

          // 这个编号的起始index
          const startIndex = relations.findIndex(item =>
            item.name === text
          )

          /*
          * 如果相同编号名的数量大于1
          * 1. 第一个做单元格合并
          * 2. 其余设置rowSpan为0
          * 不大于1正常渲染即可
          */
          if (sameCount > 1 && index <= endIndex) {
            if (index === startIndex) {
              obj.props.rowSpan = sameCount
            } else {
              obj.props.rowSpan = 0
            }
          }
          return obj
        }
      },
      {
        title: '样本编码/条码',
        dataIndex: 'sampleName',
        width: 120,
      },
      {
        title: '性别',
        dataIndex: 'sex',
        width: 80,
        render: (text, record) => {
          return (
            <div>{SEX_MAP.get(text) ? SEX_MAP.get(text) : '未知'}</div>
          )
        }
      },
      {
        title: '家系关系',
        dataIndex: 'relationName',
        width: 120,
      },
      {
        title: '致病性',
        dataIndex: 'pathogen',
        width: 120,
      },
      {
        title: '文件名称',
        dataIndex: 'path',
        width: 180,
      }
    ]
    return (
      <Table
        dataSource={relations ? relations.slice() : []}
        columns={columns}
        rowKey={record => record.path}
        pagination={false}
      />
    )
  }
}

export default SampleInfo


// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/haplotypeReport/containers/SampleInfo.js